<template>
  <div class="relative min-h-screen bg-[#0b1120] text-gray-200 overflow-hidden">
    <!-- Subtle Background Glow -->
    <div class="absolute inset-0 pointer-events-none z-0">
      <div
        class="absolute left-1/2 top-1/3 w-[1200px] h-[1200px] -translate-x-1/2 bg-red-600 opacity-10 blur-[220px] rounded-full"
      ></div>
    </div>

    <!-- Topbar -->
    <AdminTopbar class="relative z-10 print:hidden" />

    <!-- Content -->
    <main class="relative z-10 max-w-[1400px] mx-auto px-8 py-10">
      <slot />
    </main>
  </div>
</template>

<script setup>
import AdminTopbar from "@/components/admin/AdminTopbar.vue";
</script>
